export function largerMiddleMedian(values: readonly number[]): number {
  const ascending = [...values].sort((left, right) => left - right)
  return ascending[Math.floor(ascending.length / 2)]
}
